













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Title extends Vue {
  @Prop({ type: String, default: '#fff' })
  color!: string;
}
